import React from 'react';
import { PAGES } from 'src/app/common/types/types';
import HomeIcon from 'common/assets/icons/home.svg?react';
import LibraryIcon from 'common/assets/icons/library.svg?react';
import ProfileIcon from 'common/assets/icons/profile.svg?react';
import NavigationLink from './NavigationLink/NavigationLink';
import styles from './NavBar.module.scss';

const NavBar: React.FC = () => {
  return (
    <nav className={styles.navbar}>
      <NavigationLink icon={() => <HomeIcon />} text="Home" link="/" />
      <NavigationLink
        icon={() => <LibraryIcon />}
        text="Library"
        link={`/${PAGES.LIBRARY}`}
      />
      <NavigationLink
        icon={() => <ProfileIcon />}
        text="Profile"
        link={`/${PAGES.PROFILE}`}
      />
    </nav>
  );
};

export default NavBar;
